import {VotoCanalVozPath} from 'library/Routes';
import { Fade, Zoom } from '@material-ui/core';
import { CircleCheckIcon } from 'components/Icons';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import useStyle from './style';

interface Props {
  cpf: string;
  idAssembleia: string;
  todasPautasLiberadasTemVoto: boolean;
  todasPautasEncerradasOuBloqueadas: boolean;
}

const TIMEOUT_REDIRECT = 7000;

export default function ({ cpf, idAssembleia, todasPautasLiberadasTemVoto, todasPautasEncerradasOuBloqueadas }: Props) {
  const { t } = useTranslation();
  const classes = useStyle();
  const history = useHistory();

  useEffect(() => {
    window.setTimeout(() => {
      history.push(VotoCanalVozPath.replace(':idAssembleia', idAssembleia), { lastVote: cpf });
    }, TIMEOUT_REDIRECT);
  }, [history, cpf, idAssembleia]);

  return (
    <div className={classes.root}>
      <Zoom in>
        <CircleCheckIcon className={classes.icon} noFill />
      </Zoom>
      <Fade in>
        <p className={classes.title}>{t(`canalVoz.${todasPautasEncerradasOuBloqueadas ? 'semPautasLiberadasTitle' : 'finalizadaTitle'}`)}</p>
      </Fade>
      {
        !todasPautasEncerradasOuBloqueadas && (
          <Fade in>
            <p className={classes.subtitle}>{t('canalVoz.finalizadaSubtitle')}</p>
          </Fade>
        )
      }
    </div>
  );
}
